import {DisplayEvent} from "./display-event";
import {APP} from "../../../core/app/consts";
import {EntityViewModel} from "../entity/entity.view-model";
import {Type} from "../../type";

export class EntityDisplayEvent extends DisplayEvent {
  entityId: String;
  entityType: Type<EntityViewModel>;

  constructor(id: Number, entityType: String) {
    super('entity');

    this.entityId = id;
    this.entityType = entityType;
  }

  get properties() {
    const properties = super.properties;

    properties.entityId = this.entityId;
    properties.entityType = APP.ANALYTICS.ENTITY_DISPLAY_TYPES[this.entityType];

    return properties;
  }

  get isPopulated(): Boolean {
    let isPopulated = super.isPopulated;

    isPopulated &= !!this.entityId;
    isPopulated &= !!this.entityType;

    return isPopulated;
  }
}
